// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Profile / notification settings modal ---
   Reuses the login-modal shell; adds a stack of labeled toggle rows. */
.login-modal.profile-modal {
  /* At least 50% wider than the shared 340px login shell (=> >=510px) so the toggle rows and
     hints have room to breathe. The compound selector outranks the single-class .login-modal
     rule regardless of stylesheet injection order. */
  width: min(94vw, 560px);
  max-width: 560px;
}

.profile-modal {
  gap: 0.55rem;
}

.profile-modal__subtitle {
  margin: -0.2rem 0 0.4rem;
  font-size: 0.82rem;
  color: #9aa4bf;
}

.profile-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.9rem;
  padding: 0.65rem 0.75rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
}

.profile-toggle:hover {
  border-color: rgba(158, 203, 255, 0.4);
}

.profile-toggle__text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.profile-toggle__label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #e4e8f0;
}

.profile-toggle__hint {
  font-size: 0.78rem;
  color: #9aa4bf;
}

.profile-toggle__input {
  flex-shrink: 0;
  width: 1.15rem;
  height: 1.15rem;
  accent-color: #6366f1;
  cursor: pointer;
}

.profile-modal__note {
  margin: 0.1rem 0 0;
  font-size: 0.76rem;
  color: #78829e;
}
`, "",{"version":3,"sources":["webpack://./src/components/profile-modal/profile-modal.css"],"names":[],"mappings":"AAAA;uEACuE;AACvE;EACE;;qDAEmD;EACnD,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;EACxB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/* --- Profile / notification settings modal ---\r\n   Reuses the login-modal shell; adds a stack of labeled toggle rows. */\r\n.login-modal.profile-modal {\r\n  /* At least 50% wider than the shared 340px login shell (=> >=510px) so the toggle rows and\r\n     hints have room to breathe. The compound selector outranks the single-class .login-modal\r\n     rule regardless of stylesheet injection order. */\r\n  width: min(94vw, 560px);\r\n  max-width: 560px;\r\n}\r\n\r\n.profile-modal {\r\n  gap: 0.55rem;\r\n}\r\n\r\n.profile-modal__subtitle {\r\n  margin: -0.2rem 0 0.4rem;\r\n  font-size: 0.82rem;\r\n  color: #9aa4bf;\r\n}\r\n\r\n.profile-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.9rem;\r\n  padding: 0.65rem 0.75rem;\r\n  background: rgba(255, 255, 255, 0.04);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-toggle:hover {\r\n  border-color: rgba(158, 203, 255, 0.4);\r\n}\r\n\r\n.profile-toggle__text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n  min-width: 0;\r\n}\r\n\r\n.profile-toggle__label {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: #e4e8f0;\r\n}\r\n\r\n.profile-toggle__hint {\r\n  font-size: 0.78rem;\r\n  color: #9aa4bf;\r\n}\r\n\r\n.profile-toggle__input {\r\n  flex-shrink: 0;\r\n  width: 1.15rem;\r\n  height: 1.15rem;\r\n  accent-color: #6366f1;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-modal__note {\r\n  margin: 0.1rem 0 0;\r\n  font-size: 0.76rem;\r\n  color: #78829e;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
